(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-tuxedo]').forEach(card => {
      if (card.dataset.initialized) return;
      card.dataset.initialized = 'true';
      const form = card.closest('form');
      const button = form.querySelector('[type="submit"]');
      const variantInput = form.querySelector('[name="id"]');
      const toggle = card.querySelector('[data-tuxedo-toggle]');
      const body = card.querySelector('.tuxedo__body');
      const summary = card.querySelector('[data-tuxedo-summary]');
      const error = form.querySelector('[data-product-error]');
      const choices = [...card.querySelectorAll('[name="tuxedo-companion"]')];
      const text = card.dataset;
      let pending = false;
      const variant = () => (window.__taangoVariants || []).find(item => String(item.id) === variantInput.value);
      const selection = () => choices.find(input => input.checked && !input.disabled);
      const fill = (template, values) => template.replace(/\[([a-z_]+)\]/g, (match, key) => values[key] ?? match);

      function update() {
        const current = variant();
        const other = selection();
        body.hidden = !toggle.checked;
        toggle.setAttribute('aria-expanded', String(toggle.checked));
        card.classList.toggle('is-selected', toggle.checked);
        button.classList.toggle('is-bundle', toggle.checked);
        const available = current?.available && (!toggle.checked || choices.some(input => !input.disabled));
        const busy = pending || form.getAttribute('aria-busy') === 'true';
        button.disabled = busy || !available;
        button.textContent = busy ? text.adding : !available ? text.soldOut : toggle.checked ? text.add + (text.price ? ' — ' + text.price : '') : text.singleAdd;
        const values = { item: text.currentLabel, other: text.otherLabel, size: current?.title || '', other_size: other?.dataset.size || '' };
        summary.textContent = other ? fill(text.summary, values) + (text.price ? ' · ' + fill(text.forBoth, { price: text.price }) : ' · ' + text.localPricing) : fill(text.included, values);
      }

      function clearError() { error.hidden = true; error.textContent = ''; }
      form.addEventListener('taango:variant-change', () => { clearError(); update(); });
      card.addEventListener('change', () => { clearError(); update(); });
      form.addEventListener('submit', async event => {
        if (!toggle.checked) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (pending || form.getAttribute('aria-busy') === 'true') return;
        clearError();
        const current = variant();
        const other = selection();
        if (!current?.available) { update(); return; }
        if (!other) {
          error.textContent = text.choose;
          error.hidden = false;
          choices.find(input => !input.disabled)?.focus();
          return;
        }
        pending = true;
        toggle.disabled = true;
        form.setAttribute('aria-busy', 'true');
        update();
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }, { id: Number(other.value), quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : text.error);
          await window.CartDrawer.open();
        } catch (failure) {
          error.textContent = failure.message || text.error;
          error.hidden = false;
          error.focus();
        } finally {
          pending = false;
          toggle.disabled = false;
          form.removeAttribute('aria-busy');
          update();
        }
      }, true);
      card.hidden = false;
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
